var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33142 13.0019V4.66514C3.33142 3.56011 4.22722 2.66431 5.33225 2.66431H10.6678C11.7728 2.66431 12.6686 3.56011 12.6686 4.66514V13.0019C12.6687 13.127 12.5989 13.2415 12.4877 13.2987C12.3766 13.3559 12.2428 13.3462 12.1411 13.2734L8.19411 10.4536C8.07806 10.3705 7.92201 10.3705 7.80595 10.4536L3.85897 13.2727C3.75741 13.3454 3.62373 13.3553 3.51262 13.2982C3.4015 13.2412 3.33157 13.1268 3.33142 13.0019Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.315bd78b31e1307c6a0e7c1ed05d13c0.svg";
export { ForwardRef as ReactComponent };